'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107 from "./presto.-Presto-Router$$anon$107.js";
import * as $j_presto$002e$002dSigning$002dPage$0024 from "./presto.-Signing-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$106() {
  this.bdO = null;
  this.bdG = null;
  this.bdH = false;
  this.bdP = null;
  this.bdQ = false;
  this.bdT = null;
  this.bdM = null;
  this.bdN = false;
  this.bdI = null;
  this.bdJ = false;
  this.bdK = null;
  this.bdL = false;
  this.bdR = false;
  this.bdS = false;
  this.bdO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdT = "SigningPage";
}
export { $c_Lpresto_PrestoRouter$$anon$106 as $c_Lpresto_PrestoRouter$$anon$106 };
$p = $c_Lpresto_PrestoRouter$$anon$106.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$106;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$106() {
}
export { $h_Lpresto_PrestoRouter$$anon$106 as $h_Lpresto_PrestoRouter$$anon$106 };
$h_Lpresto_PrestoRouter$$anon$106.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bdO;
});
$p.L = (function() {
  if ((!this.bdH)) {
    this.bdG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdH = true;
  }
  return this.bdG;
});
$p.O = (function() {
  if ((!this.bdQ)) {
    this.bdP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdQ = true;
  }
  return this.bdP;
});
$p.E = (function() {
  return this.bdT;
});
$p.t = (function() {
  if ((!this.bdN)) {
    this.bdM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdN = true;
  }
  return this.bdM;
});
$p.M = (function() {
  if ((!this.bdJ)) {
    this.bdI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdJ = true;
  }
  return this.bdI;
});
$p.Q = (function() {
  if ((!this.bdL)) {
    this.bdK = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107.$c_Lpresto_PrestoRouter$$anon$107();
    this.bdL = true;
  }
  return this.bdK;
});
$p.w = (function() {
  if ((!this.bdS)) {
    this.bdR = false;
    this.bdS = true;
  }
  return this.bdR;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee638) => ((p) => \u03b4scrutinee638.cGh(p)))($j_presto$002e$002dSigning$002dPage$0024.$m_Lpresto_SigningPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$106 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$106, "presto.PrestoRouter$$anon$106", ({
  Nu: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$106 as $d_Lpresto_PrestoRouter$$anon$106 };
//# sourceMappingURL=presto.-Presto-Router$$anon$106.js.map
